export default __webpack_public_path__ + "static/media/matching_orange.16764202.svg";